import { Component } from '@angular/core';


@Component({
selector: 'app-sabermas',
standalone: true,
templateUrl: './sabermas.component.html',
styleUrls: ['./sabermas.component.scss']
})
export class SaberMasComponent {
  pilares = [
    {
      icon: '🎯',
      titulo: 'Misión',
      desc: 'Impulsar la transformación digital de las empresas peruanas mediante soluciones tecnológicas accesibles y eficientes.'
    },
    {
      icon: '👁️',
      titulo: 'Visión',
      desc: 'Ser el socio tecnológico líder en el Perú, reconocido por la innovación constante en sistemas de gestión y ventas.'
    },
    {
      icon: '🛡️',
      titulo: 'Confianza',
      desc: 'Garantizamos la seguridad de tus datos y el cumplimiento estricto de las normativas de SUNAT.'
    }
  ];
}